import { LabelHTMLAttributes } from "react"
import { classNames } from "utils/ClassNames"

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>

export const Label = ({ className, children, ...props }: LabelProps) => (
  <label
    className={classNames(
      "block text-sm/6 font-medium text-gray-900 dark:text-gray-100",
      className
    )}
    {...props}
  >
    {children}
  </label>
)
